/*
*
* File JS componente Products Slider
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper, { Navigation, EffectCreative } from 'swiper';
Swiper.use([Navigation, EffectCreative]);

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './new-wine-slider.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const newWineSlider = () => {

    let args = {
        slidesPerView: 2,
        loopedSlides: 1,
        speed: 1000,
        loop: true,
        loopAdditionalSlides: 100,
        initialSlide: 0,
        updateOnWindowResize: true,
        grabCursor: true,
        centeredSlides : false,
        preventClicks: false,
        preventClicksPropagation: false,
        effect: 'creative', 
        creativeEffect: {
            prev: {
                opacity: 0,
                scale: 1,
                translate: ["90%", 0, -100]
            },
            next: {
                opacity: 1,
                scale: 1,
                translate: ["-90%", 0, -100]
            },
            limitProgress: 3
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                allowTouchMove: true,
                effect: 'creative', 
                creativeEffect: {
                    prev: {
                        opacity: 0,
                        scale: 1,
                        translate: ["-150%", '-80px', -300]
                    },
                    next: {
                        opacity: 1,
                        scale: 1.1,
                        translate: ["70%", '-90px', -300]
                    },
                    limitProgress: 2
                },
                navigation: {
                    enabled: false
                },
            },
            768: {
                slidesPerView: 1,
                allowTouchMove: true,
                loop: true,
                centeredSlides : false,
                effect: 'creative', 
                // spaceBetween: 100,
                creativeEffect: {
                    prev: {
                        opacity: 0,
                        scale: 1,
                        translate: ["-100%", 0, 0]
                    },
                    next: {
                        opacity: 1,
                        scale: 1,
                        translate: ["70%", 0, -450]
                    },
                    limitProgress: 2
                },
                navigation: {
                    enabled: true
                },
            },
            1024: {
                slidesPerView: 1.6,
                allowTouchMove: true,
                loop: true,
                centeredSlides : false,
                effect: 'creative', 
                // spaceBetween: 100,
                creativeEffect: {
                    prev: {
                        opacity: 0,
                        scale: 1,
                        translate: ["-100%", 0, 0]
                    },
                    next: {
                        opacity: 1,
                        scale: 1,
                        translate: ["90%", 0, -750]
                    },
                    limitProgress: 3
                },
                navigation: {
                    enabled: true
                },
            },
            1440: {
                slidesPerView: 1.6,
                allowTouchMove: true,
                loop: true,
                centeredSlides : false,
                effect: 'creative', 
                // spaceBetween: 100,
                creativeEffect: {
                    prev: {
                        opacity: 0,
                        scale: 1,
                        translate: ["-100%", 0, 0]
                    },
                    next: {
                        opacity: 1,
                        scale: 1.35,
                        translate: ["95%", 0, -950]
                    },
                    limitProgress: 3
                },
                navigation: {
                    enabled: true
                },
            }
        }
    };
    let newWineSwipers = document.querySelectorAll('.newWineSwiper');
    newWineSwipers.forEach((el) => {
        const parent = el.parentNode;
        args.navigation.nextEl = parent.querySelector('.swiper-button-next');
        args.navigation.prevEl = parent.querySelector('.swiper-button-prev');;
        let wineSwiper = new Swiper(el, args);
        
        wineSwiper.slides.forEach((slide, index) => {
            slide.addEventListener('click', (e) => {
                if(!slide.classList.contains('swiper-slide-active')) {
                    e.preventDefault();
                    wineSwiper.slideNext();
                }
            });
        });
    })
}

export default newWineSlider;

//--------------------------------------------------------------------//